import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Link, withRouter } from 'react-router-dom';
import { replace } from 'react-router-redux';
import queryString from 'query-string';
import startsWith from 'lodash/fp/startsWith';

import LoadingPage from './pages/LoadingPage';
import AuthPage from './pages/AuthPage';
import GoalsPage from './pages/GoalsPage';

import logo from '../assets/logo.svg';
import './App.css';

function isAuthPath(pathname) {
  return startsWith('/auth/', pathname);
}

class App extends PureComponent {
  constructor(props) {
    super(props);
    const { user, location: { pathname = '/' } } = props;

    this.state = {
      loading: !isAuthPath(pathname) && (!user || pathname === '/'),
    }
  }

  _checkLogin(props) {
    const { loading } = this.state;
    const { dispatch, user, initializing, location: { pathname, search } } = props;
    if (!loading && !initializing) {
      if (user === null) {
        if (pathname !== '/auth/login') {
          let path = '/auth/login';
          if (pathname !== '/' && !isAuthPath(pathname)) {
            const args = queryString.stringify({ returnUrl: pathname });
            path += `?${args}`;
          }

          dispatch(replace(path));
        }
      } else {
        if (pathname === '/' || isAuthPath(pathname)) {
          let path = '/goals';
          if (search) {
            const params = queryString.parse(search);
            if (params.returnUrl) {
              path = params.returnUrl;
            }
          }

          dispatch(replace(path));
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user || this.props.initializing !== nextProps.initializing) {
      this._checkLogin(nextProps);
    }
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ loading: false }, () => this._checkLogin(this.props));
    }, 2000);
  }

  render() {
    const { loading } = this.state;
    const { user } = this.props;

    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2 className="kalam logo-text">Wordy Goals</h2>
          {user ? (
            <div className="login-info">
              <span className="login-name">{user.displayName}</span>
              <Link to="/auth/logout" replace>[sign out]</Link>
            </div>
          ) : null}
        </div>
        <div className="App-body">
          {loading ? <LoadingPage /> :(
            <Switch>
              <Route exact path="/" component={LoadingPage} />
              <Route path="/auth" component={AuthPage} />
              <Route path="/goals" component={GoalsPage} />
            </Switch>
          )}
        </div>
      </div>
    );
  }
}

App.propTypes = {
  // Bound properties
  dispatch: PropTypes.func,
  user: PropTypes.object,
  initializing: PropTypes.bool,
};

export default withRouter(connect(state => ({
  initializing: state.user.get('initializing', true),
  user: state.user.get('user'),
}))(App));



// WEBPACK FOOTER //
// ./src/components/App.js